import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { AuthService } from '../../services/modules/auth.service';
import { Company } from '../../models/Company';
import { MatMenuTrigger } from '@angular/material/menu';
import { environment } from 'src/environments/environment';
import { CommonMetodService } from '../../services/utils/commonMetod.service';

@Component({
  selector: 'app-select-admin',
  templateUrl: './select-admin.component.html',
  styleUrls: ['./select-admin.component.scss']
})
export class SelectAdminComponent implements OnInit {


  s3Bucket: string;
  selectedAmin: Company;
  companies: Company[];
  searchText = '';
  @ViewChild('searchAdminInput') searchAdminInput: ElementRef<HTMLInputElement>;
  @ViewChild(MatMenuTrigger) menuTrigger: MatMenuTrigger;

  @Output() _click = new EventEmitter();

  constructor(private authService: AuthService, public commonMetod: CommonMetodService) { }

  ngOnInit(): void {
    this.s3Bucket=environment.api.s3Bucket;
    this.getUserAuth();
  }

  getUserAuth() {
    this.companies = this.authService.getUser()?.Companies;
    if(this.companies.length !== 0) {
      if(this.authService.getCompany() === null) {
        this.selectedAmin = this.companies[0];
      } else {
        this.selectedAmin = this.authService.getCompany();
      }
      this.click();
    }
  }

  get filteredCompanies(): Company[] {
    const term = this.normalize(this.searchText);
    const companies = this.companies || [];
    if (!term) { return companies; }
    return companies.filter(company => this.normalize(company?.Name).includes(term));
  }

  onMenuOpened() {
    this.searchText = '';
    setTimeout(() => this.searchAdminInput?.nativeElement.focus());
  }

  // Las teclas del buscador no deben mover la seleccion del mat-menu (solo Escape lo cierra).
  onSearchKeydown(event: KeyboardEvent) {
    if (event.key !== 'Escape') {
      event.stopPropagation();
    }
  }

  selectFirstFiltered() {
    const first = this.filteredCompanies[0];
    if (first) {
      this.selected(first);
      this.menuTrigger?.closeMenu();
    }
  }

  private normalize(value: string): string {
    return String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
  }

  selected(company) {
    if(this.selectedAmin !== company) {
      this.selectedAmin = company;
      localStorage.setItem('selectedAmin', JSON.stringify(this.selectedAmin));
      this._click.emit(this.selectedAmin);
    }
  }

  click(){
    this._click.emit(this.selectedAmin);
  }
}
